<mat-form-field class="mat-form-field">
  <mat-label>{{label}}</mat-label>
  <input matInput
    [gcSelectOnClick]="true"
    [matAutocomplete]="auto"
    [required]="required"
    [formControl]="formControl"
    (blur)="onLoseFocus()" />

  @if (!disableClearButton && formControl.value) {
    <button
      mat-icon-button
      matSuffix
      aria-label="Clear"
      type="button"
      (click)="onClearSelection()">
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete"
    [displayWith]="displayWith"
    (optionSelected)="onSelectOption($event)">
    @for (option of filteredOptions; track option.id) {
      <mat-option [class.multiline]="option.subtext"
        [value]="option"
        [disabled]="option.disabled">
        {{ option.displayName }}
        @if (option.subtext) {
          <small class="subtext"
            >
            {{option.subtext}}
          </small>
        }
      </mat-option>
    }
  </mat-autocomplete>
  @if (formControl.hasError('required')) {
    <mat-error>Field is required</mat-error>
  }
  @if (hint) {
    <mat-hint>{{hint}}</mat-hint>
  }
</mat-form-field>
